// extracted by mini-css-extract-plugin
export var chatHtmlText = "_uk-2";
export var chatLink = "_uk-0";
export var chatText = "_uk-1";